/// <reference path="../include.ts" />

namespace project_guide {

	import View = alm.view.View;
	import Lang = project_common.Lang;
	import Application = project_common.Application;
	import LangUtil = project_common.LangUtil;

	export class LanguageSelector extends View<JQuery> {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(view:JQuery) {
			super(view);
			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize():JQuery {
			const view = this.getView();

			this.selector = view.find('select');
			this.current = view.find('.current');

			const langList = Application.getPresetContext().langList;
			const langCount = langList.length;
			for (let i = 0; i < langCount; ++i) {
				const lang = langList[i];
				const option = jQuery('<option value="' + lang + '">' + LangUtil.getLabel(lang) + '</option>');
				this.selector.append(option);
			}

			this.timerId = -1;

			return view;
		}

		protected implReady():void {
		}

		protected implFinalize():void {
		}

		protected implShow(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				this.selector.on('change', this.selectorChangeHandler);
				this.setSize();
			});
		}

		protected implHide(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				this.selector.off('change', this.selectorChangeHandler);
				this.stopTimer();
			});
		}





		public clearContext():void {
		}

		public setContext():void {
			this.clearContext();
			const lang = Application.getPresetContext().lang;

			this.selector.get(0).selectedIndex = this.selector.find('[value=' + lang + ']').index();
			this.setSize();
		}

		public setSize():void {
			trace('[LanguageSelector] check size');

			const width = this.current.outerWidth();
			const height = this.current.outerHeight();
			this.selector.css({ width: width, height: height });

			if (width === 0 && height === 0) {
				this.startTimer();
			} else {
				this.stopTimer();
			}
		}




		private startTimer():void {
			if (this.timerId === -1) {
				this.timerId = window.setInterval(():void => {
					this.setSize();
				}, 1000);
			}
		}

		private stopTimer():void {
			if (this.timerId != -1) {
				window.clearInterval(this.timerId);
				this.timerId = -1;
			}
		}




		private selectorChangeHandler = ():void => {
			const element = this.selector.get(0);
			const lang = <Lang>element.options[element.selectedIndex].value;
			LangUtil.saveLanguage(lang);
		};





		// --------------------------------------------------
		//
		// MEMBER
		//
		// --------------------------------------------------

		private current:JQuery;
		private selector:JQuery<HTMLSelectElement>;
		private timerId:number;
	}
}
